export const INIT = 'INIT';
export const FETCH_MACHINES = 'FETCH_MACHINES';
export const FETCH_MACHINES_SUCCESS = 'FETCH_MACHINES_SUCCESS';
export const FETCH_MACHINES_FAILURE = 'FETCH_MACHINES_FAILURE';
export const FETCH_MACHINES_UPDATED = 'FETCH_MACHINES_UPDATED';
export const FETCH_MACHINES_UPDATED_SUCCESS = 'FETCH_MACHINES_UPDATED_SUCCESS';
export const FETCH_MACHINES_UPDATED_FAILURE = 'FETCH_MACHINES_UPDATED_FAILURE';
export const FETCH_EXCHANGERATES = 'FETCH_EXCHANGERATES';
export const FETCH_EXCHANGERATES_SUCCESS = 'FETCH_EXCHANGERATES_SUCCESS';
export const FETCH_EXCHANGERATES_FAILURE = 'FETCH_EXCHANGERATES_FAILURE';
export const SET_CENTER = 'SET_CENTER';
export const SET_CENTER_TO_CURRENT_COORDINATES =
    'SET_CENTER_TO_CURRENT_COORDINATES';
export const SET_ZOOM = 'SET_ZOOM';
export const SET_MARKER = 'SET_MARKER';
export const SET_LIST_MARKERS = 'SET_LIST_MARKERS';
export const SET_LIST_ACTIVE = 'SET_LIST_ACTIVE';
export const SET_FILTER = 'SET_FILTER';
export const SET_FILTERED_ITEMS = 'SET_FILTERED_ITEMS';
export const SET_CLOSEST_FILTERED_MARKER = 'SET_CLOSEST_FILTERED_MARKER';
export const SET_USER_POS = 'SET_USER_POS';
export const SET_USER_POS_ERROR = 'SET_USER_POS_ERROR';
export const SET_MAP = 'SET_MAP';
export const SET_INFOWINDOW = 'SET_INFOWINDOW';
export const SET_EXTERNAL_GEOLOCATION = 'EXTERNAL_GEOLOCATION';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const CHECK_DEVICE = 'CHECK_DEVICE';
export const USER_POSITION_FETCHED = 'USER_POSITION_FETCHED';
export const WEBSOCKET_CONNECT_AND_LISTEN = 'WEBSOCKET_CONNECT_AND_LISTEN';
export const WEBSOCKET_MESSAGE_ADD = 'WEBSOCKET_MESSAGE_ADD';
export const WEBSOCKET_MESSAGE_CHANGE = 'WEBSOCKET_MESSAGE_CHANGE';
export const WEBSOCKET_MESSAGE_REMOVE = 'WEBSOCKET_MESSAGE_REMOVE';
export const WEBSOCKET_URL = 'WEBSOCKET_URL';
export const QUERY_MARKER_OPENED = 'QUERY_MARKER_OPENED';
export const SET_MAP_CONTAINER_DIMENSIONS = 'SET_MAP_CONTAINER_DIMENSIONS';
